import { z } from 'zod';
import { ModuleTypeSchema } from './sessions.js';
export const CentreStatusSchema = z.enum(['pending', 'approved', 'rejected']);
export const CentreSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    status: CentreStatusSchema,
    isAdmin: z.boolean(),
    ownerPhotoUrl: z.string().nullable(),
    createdAt: z.string(),
});
export const CentreStatsSchema = z.object({
    studentCount: z.number().int().nonnegative(),
    avgBand: z.number().nullable(),
    estimatedEarnings: z.number(),
});
export const CentreStudentSchema = z.object({
    userId: z.string().uuid(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    username: z.string().nullable(),
    sessionCount: z.number().int().nonnegative(),
    avgBand: z.number().nullable(),
    lastActive: z.string().nullable(),
    joinedAt: z.string(),
});
export const CentreStudentSessionSchema = z.object({
    id: z.string().uuid(),
    module: ModuleTypeSchema,
    kind: z.enum(['warm_up', 'section', 'full_test']),
    status: z.enum(['in_progress', 'completed', 'abandoned']),
    startedAt: z.string(),
    overallBand: z.number().nullable(),
});
export const CentreAuthResponseSchema = z.object({
    centre: CentreSchema,
    token: z.string(),
});
export const CentreApprovalRequestSchema = z.object({
    centreId: z.string().uuid(),
    centreName: z.string(),
    centreSlug: z.string(),
    ownerTelegramId: z.number(),
    ownerFirstName: z.string(),
    ownerLastName: z.string().nullable(),
    ownerUsername: z.string().nullable(),
    requestedAt: z.string(),
});
export const CentreApprovalQueueResponseSchema = z.object({
    requests: z.array(CentreApprovalRequestSchema),
});
export const TelegramWidgetDataSchema = z.object({
    id: z.number(),
    first_name: z.string(),
    last_name: z.string().optional(),
    username: z.string().optional(),
    photo_url: z.string().optional(),
    auth_date: z.number(),
    hash: z.string(),
});
